import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PageWrapper from "../../components/PageWrapper";
import SEO from "../../components/SEO/SEO";
import { PageIntro, Section, Title, Text } from "./design";
import QuoteCTA from "./QuoteCTA";
import { H3 } from "./ui";
import { scanningService, breadcrumbs, faqPage, guideArticle } from "./schema";
// faqs: [{ q, a }] with plain-text answers, which also feed the FAQPage schema.
// published: ISO date. Passing it marks the page as an explainer (Article
// schema) instead of a service (Service schema).
export default function DetailPage({ title, description, seoTitle, metaDescription, slug, children, faqs, published }) {
  const pathname = `/document-scanning/${slug}/`;
  return <><SEO title={seoTitle || `${title} | HotSnail Document Scanning`} description={metaDescription || description} pathname={pathname} schema={[
    published
      ? guideArticle({headline:title,description,path:pathname,published})
      : scanningService({name:title,description,path:pathname}),
    breadcrumbs([{name:"Home",path:"/"},{name:"Document Scanning",path:"/document-scanning/"},{name:title,path:pathname}]),
    ...(faqs ? [faqPage(faqs)] : []),
  ]}/><PageWrapper footerDark><PageIntro title={title}>{description}</PageIntro>{children}
    {faqs && <DetailSection title="Common questions" tint>{faqs.map(({q,a})=><div className="mt-4" key={q}><H3>{q}</H3><Text>{a}</Text></div>)}</DetailSection>}
    <QuoteCTA /></PageWrapper></>;
}
export function DetailSection({ title, children, tint = false }) {
  return <Section bg={tint ? "ash" : undefined}><Container><Row className="justify-content-center"><Col lg="9"><Title>{title}</Title>{children}</Col></Row></Container></Section>;
}
export { Text };
